import { List } from "immutable";
import { createSelector } from "reselect";

import sortDateDescending from "seneca-common/utils/functions/sorting/sortDateDescending";

import { PATH_TO_COURSE_ENROLLMENTS_STATE } from "../consts";
import CourseEnrollment from "../models/CourseEnrollment";
import { CourseEnrollments } from "../models/CourseEnrollments";
import CourseEnrollmentsStateSlice from "../models/CourseEnrollmentsStateSlice";

type CourseId = string;
type State = any;

export const getCourseEnrollmentsSlice = (
  state: State
): CourseEnrollmentsStateSlice => state.get(PATH_TO_COURSE_ENROLLMENTS_STATE);

export const getEnrolledCourses = (state: State): List<CourseEnrollment> =>
  getCourseEnrollmentsSlice(state).enrollments;

export const getEnrolledCourseIds: (arg0: State) => List<CourseId> =
  createSelector(getEnrolledCourses, (enrolledCourses: CourseEnrollments) =>
    enrolledCourses.map((e: any) => e.courseId)
  );

export const getMostRecentlyEnrolledCourseId = (
  state: State
): string | null | undefined => {
  const enrollments = getEnrolledCourses(state);

  if (enrollments.size) {
    const sortedEnrollments = enrollments.sort((a: any, b: any) =>
      sortDateDescending(a.timeEnrolled, b.timeEnrolled)
    );
    return sortedEnrollments.get(0)!.courseId;
  }
};

export const getNumberOfEnrolledCourses = (state: State): number =>
  getEnrolledCourses(state).size;

export const isEnrolledInCourse = (state: State, courseId: string): boolean => {
  const enrollments = getEnrolledCourseIds(state);
  return enrollments.includes(courseId);
};
